export default __webpack_public_path__ + "static/media/Andrea Bolloni.e19c979e.jpg";